"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACKNOWLEDGEMENT_TYPE = exports.ALERT_MESSAGE_TYPE = void 0;
exports.getRouteType = getRouteType;
function getRouteType(data) {
    var _a;
    return (_a = data.info) === null || _a === void 0 ? void 0 : _a.groupType.toLowerCase();
}
var ALERT_MESSAGE_TYPE;
(function (ALERT_MESSAGE_TYPE) {
    ALERT_MESSAGE_TYPE["PRIORITY"] = "PRIORITY";
    ALERT_MESSAGE_TYPE["SENT_ACKNOWLEDGEMENT"] = "sent-ack";
    ALERT_MESSAGE_TYPE["PENDING_ACKNOWLEDGEMENT"] = "pending-ack";
    ALERT_MESSAGE_TYPE["ACKNOWLEDGED"] = "acknowledged";
})(ALERT_MESSAGE_TYPE || (exports.ALERT_MESSAGE_TYPE = ALERT_MESSAGE_TYPE = {}));
var ACKNOWLEDGEMENT_TYPE;
(function (ACKNOWLEDGEMENT_TYPE) {
    ACKNOWLEDGEMENT_TYPE[ACKNOWLEDGEMENT_TYPE["PENDING"] = 0] = "PENDING";
    ACKNOWLEDGEMENT_TYPE[ACKNOWLEDGEMENT_TYPE["SENT"] = 1] = "SENT";
})(ACKNOWLEDGEMENT_TYPE || (exports.ACKNOWLEDGEMENT_TYPE = ACKNOWLEDGEMENT_TYPE = {}));
